module.exports = "<footer class=\"footer\"> <br>\r\n    © 2018 All rights reserved. Website developed by <a href=\"https://appzoc.com\" target=\"_blank\">Appzoc</a></footer>"


//////////////////
// WEBPACK FOOTER
// ./src/app/footer/footer.component.html
// module id = ./src/app/footer/footer.component.html
// module chunks = main